class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#HeaderCartTrigger");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log("renderContents function called");
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section, index, arr) => {
      console.log("sections render index: " + index);
      if (parsedState.sections?.[section.id]) {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    // update the top nav cart bubble

    // get items still in cart to update cart bubble
    const cartDrawerItems = document.querySelectorAll(
      "#CartDrawer-CartItems .cart-items .cart-item"
    );
    const cartIconBubbleContainer = document.getElementById(
      `cart-icon-bubble-container`
    );
    if (cartDrawerItems.length === 0) {
      cartIconBubbleContainer.style.display = "none";
      // else update cart bubble
    } else {
      let cartIconBubbleItemCount = document.getElementById(
        `cart-icon-bubble-item-count`
      );
      cartIconBubbleItemCount.innerHTML = cartDrawerItems.length;
      cartIconBubbleContainer.style.display = "block";
    }

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  //getSectionInnerHTML(html, selector = '.shopify-section') {
  // return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  //}
  getSectionInnerHTML(html, selector = ".shopify-section") {
    console.log("getSectionInnerHTML function called");
    const parsedDoc = new DOMParser().parseFromString(html, "text/html");
    const element = parsedDoc.querySelector(selector);
    if (element) {
      return element.innerHTML;
    } else {
      console.error(
        "Element with selector",
        selector,
        "not found in parsed HTML"
      );
      // Handle the case where the element is missing (e.g., return an empty string)
      return "";
    }
  }

  getSectionsToRender() {
    console.log("getSectionsToRender called v1");
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "HeaderCartTrigger",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "HeaderCartTrigger",
        section: "cart-icon-bubble-container",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
